import { queryOptions } from "@tanstack/react-query";
import { PUBLIC_QUERY_STALE_TIME } from "./public-query-cache";
import { adminListMedia, listMedia, type MediaCollection } from "@/lib/media.functions";

export const mediaQuery = (collection: MediaCollection) =>
  queryOptions({
    queryKey: ["media", collection],
    staleTime: PUBLIC_QUERY_STALE_TIME,
    queryFn: () => listMedia({ data: { collection } }),
  });

export const adminMediaQuery = (collection: MediaCollection) =>
  queryOptions({
    queryKey: ["media", "admin", collection],
    queryFn: () => adminListMedia({ data: { collection } }),
  });
